<template>
  <div>
    <b-card>
      <b-table stacked :items="items"></b-table>
    </b-card>
  </div>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import { buildInsuranceAveragesRow } from '@/core/utils/adminDataMetrics'

export default {
  components: {
    BCard,
  },
  props: {
    datarda: {
      type: Object,
      default: () => ({}),
      required: false,
    },
  },
  data() {
    return {
      items: [],
    }
  },
  watch: {
    datarda: {
      immediate: true,
      handler(val) {
        if (!val) {
          this.items = []
          return
        }
        this.items = [buildInsuranceAveragesRow(val)]
      },
    },
  },
}
</script>

<style scoped lang="scss"></style>
